package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.toMutableStateMap
import com.varabyte.kobweb.compose.css.ColorInterpolationMethod
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Right
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gridColumn
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.leftRight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onTouchMove
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.topBottom
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.ChevronDownIcon
import com.varabyte.kobweb.silk.components.icons.ChevronUpIcon
import com.varabyte.kobweb.silk.components.icons.MinusIcon
import com.varabyte.kobweb.silk.components.icons.PlusIcon
import com.varabyte.kobweb.silk.components.icons.ThreeDotsIcon
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.images.MagGlassSvg
import org.example.site_web.components.images.ThreeArrowsSvg
import org.example.site_web.components.images.WrenchSvg
import org.example.site_web.content.OfferContent
import org.example.site_web.content.ourOfferContentMap
import org.example.site_web.content.yourNeedsContentMap
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import kotlin.collections.set


val OurOfferContainerBackgroundStyle = CssStyle.base {
    Modifier.backgroundImage(
        linearGradient(
            180.deg,
            ColorInterpolationMethod.SrgbLinear
        ) {
            add(colorMode.toSitePalette().nearBackground, 0.percent)
            add(colorMode.toSitePalette().farBackground, 25.percent)
            add(colorMode.toSitePalette().farBackground, 75.percent)
            add(colorMode.toSitePalette().nearBackground, 100.percent)
        })
//        linearGradient(Colors.Green, Colors.Red,Colors.Green))
}

@Composable
fun OurOffer() {
    Column(
        YourNeedsContainerBackgroundStyle.toModifier()
            .fillMaxWidth()
            .padding(bottom = 2.em), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            Modifier.width(min(70.vw, 1344.px))
                .padding {
                    topBottom(1.em)
                }, horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {

            Span(
                Modifier.fontSize(1.8.cssRem)
                    .fontWeight(FontWeight.SemiBold).toAttrs()
            )
            {
                AccTriangleIcon()
                Text("Faisons évoluer votre situation")
            }
            Span(
                Modifier
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Lighter)
                    .toAttrs()
            ) {
                Text("Une offre de développement technique et de conseil sur-mesure adaptée aux problèmes de dirigeants et opérationnels de TPE/PME.")
            }

            Row(
                Modifier
                    .fillMaxHeight()
                    .displayIfAtLeast(Breakpoint.LG)
                    .fillMaxWidth()
                    .margin(top = 2.em)
            ) {
                Spacer()
                for (entryKey in ourOfferContentMap.keys) {
                    AnOfferEntry(entryKey,
                        Modifier
                            .width(16.em)
                            .fillMaxHeight())
                }
                Spacer()
            }
            Column(
                Modifier
                    .displayUntil(Breakpoint.LG)
                    .fillMaxWidth()
                    .margin(top = 1.em),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                for (entryKey in ourOfferContentMap.keys) {
                    AnOfferEntryHoriz(entryKey,
                        Modifier
                            .fillMaxWidth())
                }
            }
        }
    }
}


@Composable
fun AnOfferEntry(entryKey: String,
                 modifier: Modifier=Modifier) {

    val offer = ourOfferContentMap[entryKey]
    Column(
        modifier
            .fillMaxHeight()
            .backgroundColor(aiPalette.darkBackColor)
            .margin(1.em)
            .padding(1.em), horizontalAlignment = Alignment.Start
    ) {
        Row(
            Modifier,
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            OfferSvg(entryKey)
            Div() {
                Text(offer?.title ?: "NULL")
            }
        }
            Span(
                Modifier
                    .fillMaxHeight()
                    .margin(top = 0.5.em)
                    .fontSize(0.8.em)
                    .textAlign(TextAlign.Center)
                    .whiteSpace(WhiteSpace.PreWrap).toAttrs()
            ) {
                Text(offer?.content ?: "NULL")
            }
    }
}

@Composable
fun AnOfferEntryHoriz(entryKey: String,
                 modifier: Modifier=Modifier) {

    val offer = ourOfferContentMap[entryKey]
    Column(
        modifier
            .backgroundColor(aiPalette.darkBackColor)
            .fillMaxHeight()
            .fillMaxWidth()
            .margin(1.em)
            .padding(1.em), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            Modifier
                .fillMaxWidth(),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            OfferSvg(entryKey)
            Div() {
                Text(offer?.title ?: "NULL")
            }
        }
        Span(
            Modifier
                .margin(top = 0.5.em)
                .fontSize(0.8.em)
                .textAlign(TextAlign.Start)
                .whiteSpace(WhiteSpace.PreWrap).toAttrs()
        ) {
            Text(offer?.content ?: "NULL")
        }
    }
}

@Composable
fun OfferSvg(key: String) {
    when (key) {
        "GENERAL" -> {
            WrenchSvg(
                modifier = Modifier
                    .width(3.em)
                    .height(3.em)
                    .margin(right = 1.em), 50.0
            )
        }

        "LOOK" -> {
            MagGlassSvg(
                modifier = Modifier
                    .width(3.em)
                    .height(3.em)
                    .margin(right = 1.em), 50.0
            )
        }

        "ANALYSE" -> {
            ThreeArrowsSvg(
                modifier = Modifier
                    .width(3.em)
                    .height(3.em)
                    .margin(right = 1.em), 50.0
            )
        }
    }
}